import script from "./LikeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LikeModal.vue?vue&type=script&lang=ts&setup=true"

import "./LikeModal.vue?vue&type=style&index=0&id=73c91b71&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c91b71"]])

export default __exports__